import React, {Component} from 'react';
import StatusIcon from '../../components/StatusIcon';
import Appointment from '../../api/Appointment';
import ColorHelper from "../../classes/ColorHelper";
import './BCCCalendarAppointmentCell.css';
import Icon from "../Icon";
import AppointmentViewCard from "../../views/Appointments/AppointmentViewCard";
import {BioTrackPortal} from "../BiopedUI";
import {YesNoModal} from "../ModalFactory";
import {CellActionButton, ShowAcceptApp, ShowRejectConfirmModal} from "../../views/pending/PendingView";

const prefIcon = {
	email: 'email',
	cell: 'text',
	phone: 'call',
	work: 'call',
	PHON: 'call',
	SMSM: 'text',
	EMAL: 'email'
};


export default class BCCalendarAppointmentCell extends Component{
	static colors = [
		'#F9A14A',
		'#5D4DA1',
		'#C1198B',
		'#42A444'
	];

	state = {};

	setDom = (ref) => {
		this.setState({
			dom: ref
		})
	}


	formatTime(time){

		let format =  'h:mm a';
		if(time.minute() == 0){
			format = 'h a';
		}

		return time.format(format);

	}

	setDetailState = (isVisible, delay = 500) => {
		if(this.timeOutId != null){
			clearTimeout(this.timeOutId);
			//this.timeOutId = null;

		}
		this.timeOutId = setTimeout(() => {
			this.setState({showDetails: isVisible});
			this.timeOutId = null;
		}, delay)
	}

	onMouseEnter = (e) => {
		this.setDetailState(true)
	}

	onMouseLeave = (e) => {
		this.setDetailState(false);
	}

	onClickOutside = (x, y) => {
		this.setDetailState(false, 0);
	}

	/**
	 *
	 * @param style - popover container stlye object
	 * @param bounds - target object to follow bounds
	 * @param container - popover container dom ref
	 * @param arrow - popover arrow style ref
	 */
	popoverFunc = (style, bounds, container, arrow) => {
		let cbounds = container.getBoundingClientRect();

		style.left = '';
		style.right = '';

		const offset = 6;

		arrow.display = 'block';

		//console.log('br', bounds.right, 'bw', cbounds.width,'innerWidth', window.innerWidth);

		if((bounds.right + cbounds.width) > window.innerWidth || !cbounds.width){
			style.left = ((bounds.left - offset) - cbounds.width) + 'px';
			arrow.left = '100%';
		} else {
			style.left = (bounds.right + offset) + 'px';
		}

		let top = (bounds.top + (bounds.height/2));

		if((top + cbounds.height/2) > window.innerHeight){
			top -= ((top + cbounds.height/2) - window.innerHeight)
		}

		if((top - cbounds.height/2) < 0){
			top -= (top - cbounds.height/2)
		}


		//style.left = bounds.right + 'px';
		style.top = top + 'px';
		style.transform = 'translateY(-50%)'


		let arrowTop = (bounds.top - top) + bounds.height/2;

		arrow.top = `calc(50% + ${arrowTop}px)` ;

	}




	render(){
		//let time = this.formatTime(this.state.timeStart) + " - " + this.formatTime(this.state.timeEnd);
		let time = null;
		let app = this.props.appointment;
		let user = app.client;
		if(this.state.timeStart){
			time = this.formatTime(this.state.timeStart) + " - " + this.formatTime(this.state.timeEnd);
		} else{
			time = Appointment.FormatTimeRange(app);
		}

		let inverse = '#ffffff'; // ColorHelper.GetInverse('#' + app.appointmentType.color);
		const appColor = (app.appointmentType || {}).color || '';
		let style = {
			backgroundColor:'#' + appColor,
			color: inverse,
			textShadow: "0px 0px 4px " + ColorHelper.GetInverse(inverse)
		}

		let reminder = (app.reminders || [])[0] || {};

		let contactMethod = prefIcon[reminder.notificationTypeCd]; //prefIcon[user.preferredContactMethod];
		return (
			<div
				key={'App_Cell' + app.externalAppointmentId}
				className="calendar-item bc-calendar-item" style={style}
				grid-item={this.props['grid-item']}
				ref={this.setDom}
				onMouseEnter={this.onMouseEnter}
				onMouseLeave={this.onMouseLeave}
			>
				<Icon icon={'alertTag'} className='alert-tag' />
				<div className="name">{app.clientFirstName} {app.clientLastName} ({app.appointmentSourceCode})</div>
				<div className="time">{time}</div>
				<StatusIcon icon={contactMethod} status={app.status}/>
				{this.state.isBusy ? <span className="Select-loading" /> : null}
				<BioTrackPortal
					className={'app-popover'}
					isVisible={this.state.showDetails}
					target={this.state.dom}
					posFunc={this.popoverFunc}
					onClickOutside={this.onClickOutside}
				>
					<div className='bcc-actions'>
						<CellActionButton className={'hover-green'} icon={'check'} title={'Approve'}
							                  onClick={()=> {
								                  ShowAcceptApp(app);
							                  }}
						/>
						<CellActionButton className={'hover-red'} icon={'x'} title={'Reject'} onClick={() => {
							ShowRejectConfirmModal(app);
						}}/>
					</div>
				</BioTrackPortal>
			</div>
		)
	}
}

/*class AppCellView extends Component{

    render(){
        let {app, ...props} = this.props;

        let user = app.client;
        let contactMethod = prefIcon[user.preferredContactMethod];
        let style = {
            backgroundColor: '#' + app.appointmentType.color
        }
        return(
            <div className={SanitizeClassNames(this, 'app-detail')} style={style} {...props}>
                <div className="name">{user.fullName}</div>
                <StatusIcon icon={contactMethod} status={app.status} />
            </div>
        )
    }
}*/



// WEBPACK FOOTER //
// ./src/components/biopedConnect/BCCalendarAppointmentCell.js